<template>
  <div class="header">
    <div class="logo-con">
      <img :src="maxLogo" key="max-logo"/>
    </div>
    <div class="header-left">
      <span>{{ $t('title') }}</span>
    </div>
    <div class="header-right">
      <div class="header-user">
        <!--        <div class="bell">-->
        <!--          <div class="el-icon-bell " @click="messageVisible = !messageVisible"></div>-->
        <!--        </div>-->
        <!-- 国际化   -->
        <el-dropdown style="margin-right: 24px" trigger="hover" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $t('language') }}<i class="el-icon-caret-bottom"></i>
            </span>
          <el-dropdown-menu class="dropdown-menu" slot="dropdown">
            <el-dropdown-item command="setChinese">
              <i class="header-icon"></i>{{ $t('chinese') }}
            </el-dropdown-item>
            <el-dropdown-item divided command="setEnglish">
              <i></i>{{ $t('english') }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 用户头像 -->
        <div class="user">
          <i class="iconfont iconyonghu"></i>
          <span class="username" @click="userInfoVisible = !userInfoVisible">{{ username }}</span>
          <span style="padding-left: 24px;cursor: pointer" @click="silence">
              <img :src="audioSrc" alt="">
            </span>
          <span style="padding-left: 24px;cursor: pointer" @click="download" :title="$t('download_center')">
               <img src="../../assets/img/header/down.png" alt="">
            </span>
          <span style="color: red; padding-left: 24px;cursor: pointer" @click="logout" :title="$t('logout')">
              <img src="../../assets/img/header/exit.png" alt="">
            </span>
        </div>
      </div>
    </div>
    <download-dialog/>
    <user-info-dialog :visible.sync="userInfoVisible"></user-info-dialog>
    <message ref="message" :visible.sync="messageVisible"></message>
    <el-dialog width="350px" title="修改密码" :visible.sync="resetPasswordVisible">
      <el-form :model="resetPasswordForm" :rules="resetPasswordRules" ref="resetPasswordForm">
        <el-form-item prop="oldPwd">
          <el-input :show-password="true" v-model="resetPasswordForm.oldPwd" placeholder="旧密码" clearable></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input :show-password="true" v-model="resetPasswordForm.password" placeholder="新密码" clearable></el-input>
        </el-form-item>
        <el-form-item prop="password2">
          <el-input :show-password="true" v-model="resetPasswordForm.password2" placeholder="确认密码" clearable></el-input>
        </el-form-item>
        <div style="text-align: center">
          <el-button type="primary" icon="el-icon-ops-save" :loading="resetPasswording"
                     @click="resetPassword">修改
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import audio from "../../assets/img/header/audio.png"
import audioNone from "../../assets/img/header/audioNone.png"
import Message from './Message'
import {logout} from "api/remote";
import DownloadDialog from "@/view/index/DownloadDialog";
import UserInfoDialog from "./UserInfoDialog";
import maxLogo from '@/assets/img/logo-1.png'
export default {
  name: "headerBar",
  components: {UserInfoDialog, DownloadDialog, Message},
  data() {
    // 校验官方账号权限和密码
    let checkPassword = (rule, password2, callback) => {
      if (this.resetPasswordForm.password === password2) {
        return callback()
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        return callback('两次输入密码不一致')
      }
    }
    return {
      audioSrc:audio,
      audio,
      audioNone,
      userInfoVisible: false,
      messageVisible: false,
      resetPasswordVisible: false,
      resetPasswordForm: {
        oldPwd: null,
        password: null,
        password2: null
      },
      resetPasswordRules: {
        oldPwd: [
          {required: true, message: '请填写旧密码', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请填写新密码', trigger: 'blur'}
        ],
        password2: [
          {required: true, message: '请确认新密码', trigger: 'blur'},
          {validator: checkPassword, trigger: 'blur'}
        ]
      },
      resetPasswording: false,
      path: this.$route.path,
      chartActiveArr: ['/chart/deviceAnalyse', '/chart/projectAnalyse', '/dataStatistics'],
      emailActiveArr: ['/emailSender', '/emailRecord'],
      showUpdate: false,
      showEmailManage: false,
      maxLogo,
    }
  },
  methods: {
    // 用户名下拉菜单选择事件
    changeSelected() {
      this.dataImportSelected = true
      this.historyQuerySelected = false
    },
    adCls() {
      return this.dataImportSelected ? 'selected-nav' : ''
    },
    logout() {
      logout().then(() => {
        sessionStorage.clear();
        localStorage.clear();
        // 清空 vuex
        window.location.reload();
        this.$router.replace('/login')
      })
    },
    download() {
      this.$root.$emit("show-download-dialog");
    },
    handleCommand(command) {
      if (command === 'setChinese') {
        this.$i18n.locale = 'chinese'
        this.$store.commit('setLanguage', 'chinese');
      }
      if (command === 'setEnglish') {
        this.$i18n.locale = 'english'
        this.$store.commit('setLanguage', 'english');
      }
    },
    resetPassword() {
      this.$refs.resetPasswordForm.validate(valid => {
        if (!valid) return false
        // this.resetPasswording = true
        // TODO
        changePassword({
          newPwd: this.resetPasswordForm.password,
          oldPwd: this.resetPasswordForm.oldPwd
        }).then(res => {
          this.resetPasswordVisible = false
          this.$message.success('密码修改成功！')
          setTimeout(() => {
            this.$router.replace('/')
          }, 300)
        })
      })
    },
    closeVisble() {
      this.showUpdate = false
    },
    silence(){
      //
      let flag = !this.muteFlag
      this.audioSrc = flag ? this.audioNone : this.audio;
      this.$store.commit("setMuteFlag", flag)
      sessionStorage.muteFlag = flag;
    }
  },
  computed: {
    username() {
      return this.$store.state.userInfo.name
    },
    route() {
      return this.$route
    },
    muteFlag(){
      return this.$store.state.muteFlag
    }
  },
  watch: {
    route(val) {
      this.path = val.path
    }
  },
  mounted() {
    if (localStorage.getItem('jbf_cloud_loginName') === 'wx') {
      this.showEmailManage = true
    } else {
      this.showEmailManage = false
    }
    this.audioSrc = this.muteFlag ? this.audioNone : this.audio;
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 50px;
  width: 100%;
  font-size: 22px;
  color: #2F4E68;
  .logo-con {
    float: left;
    box-sizing: border-box;
    height: 50px;
    padding: 3px 10px 0 0;
    img {
      height: 44px;
      width: auto;
      display: block;
      margin: 0 auto;
    }
  }
  .header-left {
    float: left;
    line-height: 50px;
  }

  .header-right {
    float: right;
    .header-user {
      display: flex;
      height: 50px;
      align-items: center;

      .language {
        margin-right: 30px;
        position: relative;
      }

      .bell {
        margin-right: 24px;
        position: relative;
      }

      .user {
        float: right;
        font-size: 14px;
        .username{
          display: inline-block;
          position: relative;
          top:-3px;
        }
        .iconfont {
          line-height: 50px;
          font-size: 25px;
          margin-right: 10px;
        }
      }
    }
  }
}

.top-menu {
  color: #fff;
  font-size: 18px;
}

.el-dropdown-menu--mini .el-dropdown-menu__item {
  line-height: 24px;
  padding: 6px 16px;
  font-size: 14px;
  z-index: 999999;
}
</style>
